import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Logo from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { PHONE_DISPLAY, PHONE_TEL } from "../data/mock";

export default function Login() {
  const [email, setEmail] = useState("");

  return (
    <div className="min-h-screen bg-cream grain flex flex-col">
      <header className="px-6 md:px-10 py-6">
        <Link to="/">
          <Logo />
        </Link>
      </header>
      <div className="flex-1 flex items-center justify-center px-6">
        <div className="w-full max-w-md bg-white rounded-3xl border border-navy/10 shadow-xl p-8 md:p-10">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-teal mb-2">Client Login</p>
          <h1 className="font-grotesk text-3xl font-bold text-navy mb-1">Welcome back.</h1>
          <p className="text-navy/60 text-sm mb-8">Sign in to your CallRetrieve dashboard.</p>

          <div className="space-y-5">
            <div>
              <Label className="font-mono text-[11px] uppercase tracking-[0.18em] text-navy/50">Work email</Label>
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="jane@yourbusiness.com"
                className="mt-2 h-12 bg-cream border-navy/10 rounded-xl"
              />
            </div>
            <div>
              <Label className="font-mono text-[11px] uppercase tracking-[0.18em] text-navy/50">Password</Label>
              <Input type="password" placeholder="••••••••" className="mt-2 h-12 bg-cream border-navy/10 rounded-xl" />
            </div>
            <Button className="w-full h-12 rounded-full bg-navy text-cream hover:bg-navy-800 font-grotesk font-semibold">
              Sign in
            </Button>
          </div>

          <p className="text-center text-xs text-navy/50 mt-6">
            Not a client yet? Call{" "}
            <a href={`tel:${PHONE_TEL}`} className="text-teal font-semibold">{PHONE_DISPLAY}</a>
          </p>
        </div>
      </div>
      <div className="px-6 md:px-10 py-6">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-navy/60 hover:text-navy transition-colors">
          <ArrowLeft className="w-4 h-4" /> Back to home
        </Link>
      </div>
    </div>
  );
}
